import { render, staticRenderFns } from "./AssignPersonal.vue?vue&type=template&id=452a3b42"
import script from "./AssignPersonal.vue?vue&type=script&lang=js"
export * from "./AssignPersonal.vue?vue&type=script&lang=js"
import style0 from "../ApplicationReviewers.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./AssignPersonal.vue?vue&type=style&index=1&id=452a3b42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports